export function createTurno() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    Alias: '',
    Descripcion: '',
    FechaDesde: '',
    FechaHasta: '',
    HoraDesde: '08:00',
    HoraHasta: '17:00',
    DiasLaborables: '1,2,3,4,5',
    CruzaDia: false,
    MinutosDescanso: 60,
    MinutosToleranciaEntrada: 0,
    MinutosToleranciaSalida: 0,
    EsPredeterminado: false,
    Color: '#2563eb',
    ClaveErp: '',
    Orden: 0,
    EsSistema: false,
    EsActivo: true
  };
}
